<template>
  <div class="page" id="material-page">
    <div class="textLayout">
      <!-- <yd-cell-group title="报销类目（必填）">
        <yd-cell-item>
            <yd-input slot="right" v-model="title" :debug="true" placeholder="请填写报销类目"></yd-input>
        </yd-cell-item>
      </yd-cell-group> -->
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 报销类目（必填）</div>
        <div class="inp">
           <van-field
            v-model="title"
            placeholder="请填写报销类目"
            
          />
        </div>
      </div>
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 报销费用（必填 单位：元）</div>
        <div class="inp">
           <van-field
             v-model="priceStr"
             type="number"
            placeholder="请填写需要报销的金额"
            
          />
        </div>
      </div>
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 费用说明（必填）</div>
        <div class="inp">
           <van-field
            v-model="remark"
            placeholder="请对上传内容作简要介绍"
            rows="4"
            type="textarea"
            autosize
          />
        </div>
      </div>
      <div class="item" style="padding:0 15px;box-sizing:border-box">
        <div class="title" style="display: flex;align-items: center;font-size:13px;height: 40px;"> <div style="width:3px;height:13px;background:#67cf22;margin-right:10px"></div> 上传图片（例如发票和凭据，最多上传六张）</div>
        <div class="inp">
           <div class="pictureAddLayout">
              <div v-for="(item, index) in uploadArray" :key="index">
                  <Uploader v-bind:url="remoteUrl"
                        v-bind:data="formData"
                        v-bind:type=2
                        v-bind:index=index
                        @success="uploadSuccess($event)"
                        @error="uploadError($event)"
                        v-if="initOssEnd && (index<=netImageUrls.length)">
                </Uploader>
              </div>
            </div>
        </div>
      </div>
      <!-- <br>
      <yd-cell-group title="报销费用（必填 单位：元）">
        <yd-cell-item>
            <yd-input slot="right" v-model="priceStr" :debug="true" placeholder="请填写需要报销的金额"></yd-input>
        </yd-cell-item>
      </yd-cell-group>
      <br>
      <yd-cell-group title="费用说明（必填）">
        <yd-cell-item>
            <yd-textarea slot="right" v-model="remark" placeholder="请对上传内容作简要介绍" maxlength="1000"></yd-textarea>
        </yd-cell-item>
      </yd-cell-group>
      <br> -->
      <!-- <div class="uploadPictureTitleLayout">
        上传图片（最多上传六张）
      </div> -->
      <yd-button class="submitButtonLayout" size="large" type="primary" @click.native="submitAction()">提   交</yd-button>    
    </div>
    <!-- <div class="pictureAddLayout">
      <div v-for="(item, index) in uploadArray" :key="index">
          <Uploader v-bind:url="remoteUrl"
                v-bind:data="formData"
                v-bind:type=2
                v-bind:index=index
                @success="uploadSuccess($event)"
                @error="uploadError($event)"
                v-if="initOssEnd && (index<=netImageUrls.length)">
        </Uploader>
      </div>
    </div> -->
    
  </div>
</template>

<script>
import Uploader from '@/pages/common/Uploader'
import appService from '@/services/request/appService'
import store from 'store'
export default {
  name: 'ScheduleMaterial',
  components: {
    Uploader
  },
  data() {
    return {
      mine:{},
      groupId: this.$route.query.groupId,
      title: "",
      priceStr:"",
      remark:"",
      remoteUrl: "",
      formData: {},
      initOssEnd: false,
      uploadArray:[1,2,3,4,5,6],
      netImageUrls:[],
    }
  },
  mounted:function() {
    this.$nextTick(function() {
      document.title = "上传材料"
      this.mine = store.get('mine') || {}
      this.initOssParams();

      let height = window.innerHeight
      let el = document.getElementById('material-page')
      el.style.minHeight = height + 'px'
    })
  },
  methods: {
    initOssParams() {
      appService
        .getOssParams()
        .then(
          result => {
            var ossInfo = result
            var key = "h5/" + this.mine.iid + "_" + new Date().getTime()
            this.remoteUrl = "https://fimage.oss-cn-shenzhen.aliyuncs.com/"
            this.formData = {
              key: key,
              policy: ossInfo.policy,
              OSSAccessKeyId: ossInfo.accessKeyId,
              success_action_status: "200", //让服务端返回200,不然，默认会返回204
              signature: ossInfo.sign,
              expire_time: ossInfo.expireTime
            };
            this.initOssEnd = true
          },
        error => {}
      );
    },
    uploadSuccess(res) {
      var haveNetImageUrl = false
      for(var i = 0; i < this.netImageUrls; i++) {
        var unit = this.netImageUrls[i]
        if(res.index == unit.index) {
          haveNetImageUrl = true
          unit.imageUrl = res.previewUrl
          break
        }
      }
      if(!haveNetImageUrl) {
        var item = {
          index: res.index,
          imageUrl: res.previewUrl
        }
        this.netImageUrls.push(item)
      }
    },
    uploadError(res) {
      console.log("上传失败");
    },
    submitAction() {
      var imagePaths = []
      var k = 0
      while(k < this.netImageUrls.length) {
        var item = this.netImageUrls[k]
        imagePaths.push(item.imageUrl)
        k++
      }
      var imagePathJsonStr = JSON.stringify(imagePaths)
      if(!this.title){
        this.$toast('请填写报销类目')
        return
      }
      if(!this.priceStr){
        this.$toast('请填写报销费用')
        return
      }
      appService
        .addMaterial({
          id: this.groupId,
          rid: store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          unionId: store.get('loginData') ? store.get('loginData').id : this.mine.unionId, 
          title: this.title,
          imagePath: imagePathJsonStr,
          price: this.priceStr,
          remark: this.remark,
          nickName: store.get('loginData')?store.get('loginData').nickname +( '(' + store.get('loginData').loginName + ')' ):this.mine.nickName,
          phone: store.get('loginData') ? store.get('loginData').loginName : this.mine.phone,
          iid: this.$route.query.iid,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          this.$dialog.toast({
            mes: '材料已上报',
            timeout: 1500,
            icon: 'success',
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 1500);
        }, error => {
          var errorDesc = '材料上传失败'
          if (error && error.sub_msg) {
            errorDesc = error.sub_msg
          }
          this.$dialog.toast({
            mes: errorDesc,
            timeout: 1500,
            icon: 'error',
          });
        })
    },
  },
}
</script>

<style scoped lang="less">
.page {
  font-size: 0.28rem;
  /* padding-bottom: 2rem; */
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background: #fff;
}
.inp{
  & /deep/ textarea{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
    border-radius: 5px;
    padding: 3px;
    box-sizing: border-box;
  }
  & /deep/ input{
    // box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
    border-radius: 5px;
    padding: 3px;
    box-sizing: border-box;
  }
}
.textLayout{
  /* background-color: #f6f6f6; */
  font-size: 16px;
  background: #fff;
  /* padding: 12px; */
  /* padding-bottom: 6px; */
}
.uploadPictureTitleLayout{
  position: relative;
  text-align: left;
  color: #888;
  font-family: arial,sans-serif;
  font-size: .28rem;
  font-weight: 100;
  padding: 0.05rem .2rem 0.05rem;
  z-index: 1;
}
.pictureAddLayout{
  display: content;
  position: relative;
  margin-top: 6px;
  margin-left: 16px;
}
.submitButtonLayout{
  align-content: center;
  align-items: center;
  position: fixed;
  bottom: 16px;
  padding: 12px auto;
  width: 80%;
  left: 10%;
  right: 10%;
  font-size: 16px;
  z-index: 1000;
  text-shadow: lightgray;
  background: rgb(103, 207, 34);
  border-radius: 45px;
}
</style>
